export default "__VITE_ASSET__hce4ajTU__"